export const API_ROOT = '/ICSXapi/testplayer/';
export const ASSESSMENT_ROOT = '/ICSXapi/assessment/';
export const DASHBOARD_ROOT = '/ICSXapi/dashboard/';
export const REMOTE_PROCTORING_ROOT = '/ICSXapi/remoteproctoring/';

export const TEST_FILE = 'https://d2snzxottmona5.cloudfront.net/lib/empty.html';

export const methods = {
    CHECK_CODE_COMPILATION: 'CheckSourceCodeCompilation',
    CHECK_CODE_EVAL_TEST_CASES: 'CheckSourceCodeAgainstEvaluationTestCases',
    CHECK_STORED_ITEMS: 'CheckStoredItems',
    DELIVER_BLANK: 'DeliverBlank',
    DELIVER_TEST: 'DeliverTest',
    ENTER_ORAL_EXAM_WAITING_ROOM: 'EnterOralExamWaitingRoom',
    EVALUATE_BRANCH_RULE: 'EvaluateBranchRule',
    EVICT_PROCTOR_FROM_LIVE_SESSION: 'EvictFromLiveSession',
    GENERATE_NTS_TOKEN: 'GenerateNTSToken',
    GET_CHILD_TESTS: 'GetChildTests',
    GET_CORRECT_RESPONSES: 'GetCorrectResponses',
    GET_DELIVERY_DETAILS: 'GetSubmissionDetails',
    GET_FEEDBACK: 'GetFeedback',
    GET_MESSAGES: 'GetMessages',
    GET_PRECHECKS_SETTINGS: 'GetPrechecksSettings',
    GET_QUESTION_SET: 'GetQuestionSet',
    GET_QUESTION: 'GetQuestion',
    GET_REMAINING_TIME: 'GetRemainingTime',
    GET_REMOTE_ORAL_EXAM_SESSION_INFO: 'GetRemoteOralExamSessionInfo',
    GET_SECTION: 'GetSection',
    GET_SETTINGS: 'GetSettings',
    GET_SIGNED_WEB_SOCKET_URL: 'GetSignedWebSocketUrl',
    GET_SKETCH_CODE_FOR_QUESTION: 'GetSketchCodeForQuestion',
    GET_SKETCH_CODES: 'GetSketchCodesForCandidate',
    GET_TTS_ACCESS_INFO: 'GetTTSAccessInfo',
    GET_TTS_AUDIO_URL: 'GetTTSAudioUrl',
    GET_TEST_TAKER_O365_FILE_METADATA: 'GetTestTakerO365FileMetadata',
    GET_O365_FILE_URL: 'GetO365FileUrl',
    GET_UNREAD_MESSAGES: 'GetUnreadMessages',
    GET_UPLOAD_TICKET: 'GetUploadTicket',
    GET_UPLOADER_INFO: 'GetUploaderInfo',
    GET_USER_RESPONSE: 'GetUserResponse',
    GET_USER_RESPONSES: 'GetUserResponses',
    GET_DESCRIBE_LOGGED_IN_USER: 'DescribeLoggedInUser',
    GET_SS_ACCESS_TOKEN: 'Wopibootstrapper',
    GET_ZOOM_HUICHANG_TEST_CALL_DETAIL: 'GetZoomHuichangDemoMeeting',
    GET_ZOOM_TEST_CALL_DETAIL: 'GetZoomTestCallDetail',
    GET_ATTEMPTED_ANSWERSHEET_METADATA: 'getattemptedanswersheetmetadata',
    ID_VERIFICATION_REQUEST_PROPERTIES: 'GetLatestRemoteProctoringSessionForUserTestSetup',
    NOTIFY_CLIENT_EVENT: 'NotifyClientEvent',
    REQUEST_MANUAL_ID_VERIFICATION: 'RequestManualIdVerification',
    SEND_LIVE_SESSION_ANSWER: 'SendLiveSessionAnswer',
    SEND_LIVE_SESSION_BACK_ONLINE_NOTICE: 'SendLiveSessionBackOnlineNotice',
    SEND_LIVE_SESSION_CANDIDATE_ONLINE_CONFIRMATION: 'ConfirmLiveSessionCandidateOnline',
    SEND_LIVE_SESSION_ICE_CANDIDATES: 'SendLiveSessionICECandidates',
    SEND_LIVE_SESSION_RECOVERY_ANSWER: 'SendLiveSessionRecoveryAnswer',
    SEND_REMOTE_ORAL_EXAM_STATUS: 'SendRemoteOralExamStatus',
    SEND_PROCTORING_SESSION_ESTABLISHED_NOTICE: 'SendProctoringSessionEstablishedNotice',
    SET_BACKGROUND_AUDIO_POSITION: 'SetBackgroundAudioPosition',
    START_COUNTDOWN: 'StartCountdown',
    START_LIVE_SESSION: 'StartLiveSession',
    START_TEST: 'StartTest',
    STORE_USER_RESPONSE: 'StoreUserResponse',
    SUBMIT_CODE_EVAL_TEST_CASES: 'SubmitSourceCodeAgainstEvaluationTestCases',
    SUBMIT_CODE_FOR_COMPILATION: 'SubmitSourceCodeForCompilation',
    UPLOAD_AUTOMATIC_ID_VERIFICATION_PHOTOS: 'UploadAutomaticIdVerificationPhotos',
    UPLOAD_SUCCESS: 'UploadSuccess',
    VALIDATE_DAY_CODE: 'ValidateDayCode',
    VCC: '/vcc',
    WITHDRAW: 'Withdraw',
};

export const responseCategories = {
    FORBIDDEN: 'FORBIDDEN',
    HTTP_ERROR: 'HTTP_ERROR',
    INVALID_TAB_TOKEN: 'INVALID_TAB_TOKEN',
    NOT_LOGGED_IN: 'NOT_LOGGED_IN',
    OFFLINE: 'OFFLINE',
    OK: 'OK',
    RESPONSE_PARSING_ERROR: 'RESPONSE_PARSING_ERROR',
    SERVER_ERROR: 'SERVER_ERROR',
    TIMEOUT: 'TIMEOUT',
    WRONG_TOKEN: 'WRONG_TOKEN',
};

export const safeBrowserLinks = {
    QUIT: 'http://ia.inspera.no/quit',
    COMPLETED: 'ia.inspera.no/completed',
    CLEAR_CLIPBOARD: 'https://ia.inspera.no/iepClearPasteboard',
    TALVIEW_BROWSER_DOWNLOAD_URL: 'https://pages.talview.com/securebrowser/',
    DISABLE_EXIT_URL: 'https://ia.inspera.no/iibDisableExit',
    ENABLE_EXIT_URL: 'https://ia.inspera.no/iibEnableExit',
    MIC_WEBCAM_HARDWARE_PRECHECK_COMPLETE: 'https://ia.inspera.no/hardwarePrechecksCompleted',
    LAST_PAGE_TAB_NAVIGATION_COMPLETE: 'https://inspera.com/accessibility/lastPageTabNavigationComplete',
};
